// /ops/alerts — оповещения сопровождению (002, contracts/ui.md): действующие и история за срок
// хранения. Право — ops.alerts.read: роль «сопровождение». Переключатель «Действуют» / «История»,
// вид, период и сортировка — в адресе страницы (?view=history&kind=&from=&to=&sort=): ссылку
// можно переслать, назад — то же.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { AlertsPage } from '../../features/ops/AlertsPage.tsx';
import { parseAlertsSearch } from '../../features/ops/alerts-search.ts';
import type { AlertsSearch } from '../../features/ops/alerts-search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/ops/alerts')({
  validateSearch: parseAlertsSearch,
  beforeLoad: requireSection('alerts'),
  staticData: { crumb: 'Оповещения' },
  component: AlertsRoute,
});

function AlertsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: AlertsSearch) => void navigate({ to: '/ops/alerts', search: next, replace: true }),
    [navigate],
  );
  return <AlertsPage search={search} onSearchChange={onSearchChange} />;
}
